import { render, staticRenderFns } from "./oneMoreOrderDetail.vue?vue&type=template&id=eb11ffc4&scoped=true"
import script from "./oneMoreOrderDetail.vue?vue&type=script&lang=ts"
export * from "./oneMoreOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./oneMoreOrderDetail.vue?vue&type=style&index=0&id=eb11ffc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb11ffc4",
  null
  
)

export default component.exports